import script from "./ProfilRisqueQuestionnaire.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfilRisqueQuestionnaire.vue?vue&type=script&setup=true&lang=js"

import "./ProfilRisqueQuestionnaire.vue?vue&type=style&index=0&id=fe036642&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe036642"]])

export default __exports__